import React, { useState } from "react";
import useReactionHover from "../../utility/useReactionHover";
import { motion } from "framer-motion";
import axios from "../../API/axios";
import { toast } from "react-hot-toast";
import CommentReply from "./CommentReply";
import SuccessToast from "../SuccessToast";
import WarningToast from "../WarningToast";
import ErrorToast from "../ErrorToast";
import { post } from "../../config/imagesLink";
import LikesDetails from "./LikesDetails";
import { useTranslation } from "react-i18next";
import ModalForGuest from "../ModalForGuest";

const {
  like,
  celebrate,
  support,
  love,
  insightful,
  funny,
  likegif,
  commentLike,
} = post;

const CommentAction = ({
  item,
  AllPostList,
  setPostList,
  postId,
  emojiList,
  updateCommentLike,
}) => {
  console.log("commentres", item);
  const sessionId = localStorage.getItem("sessionId");
  const {
    isHovered,
    isHoveredRelike,
    setIsHovered,
    setIsHoveredRelike,
    openLikeBar,
    openRelikeBar,
    closeLikeBar,
    closeRelikeBar,
  } = useReactionHover();
  const { t } = useTranslation();
  const [toastMessage, setToastMessage] = useState("");
  const [showToast, setShowToast] = useState(false);
  const guestModeData = localStorage.getItem("guestMode");
  const [warningToastMessage, setWarningToastMessage] = useState("");
  const [showWarningToast, setShowWarningToast] = useState(false);
  const language = localStorage.getItem("Lang");
  const [ErrorToastMessage, setErrorToastMessage] = useState("");
  const [showErrorToast, setShowErrorToast] = useState(false);
  const restrictedViewerToken = localStorage.getItem("restrictedViewerToken");

  const list = {
    visible: {
      opacity: 1,
    },
    hidden: {
      opacity: 0,
    },
  };

  //************************like Post start  ************************//
  const [selectedImg, setSelectedImage] = useState("");
  const [isLiking, setIsLiking] = useState(false);
  const [isLiked, setIsLiked] = useState(!!item?.isLiked);
  const [likedType, setLikedType] = useState(item?.likedType ?? null);
  const currentCommentId = item?.pstCmntId ?? item?.commentId;

  React.useEffect(() => {
    setIsLiked(!!item?.isLiked);
    setLikedType(item?.likedType ?? null);
  }, [item?.isLiked, item?.likedType]);
  const LikePost = async (liketype, imageName) => {
    if (isLiking) return;
    const responseData = {
      deviceType: "Web",
      sessionId: sessionId,
      pstCmntId: currentCommentId,
      likeType: liketype,
      langKey: language === "en" ? "" : language,

    };
    setIsLiking(true);
    setLikedType(liketype);
    setTimeout(async () => {
      try {
        await axios.post(`PostAction/LikeComment`, responseData).then((res) => {
          // console.log(res);
          //   toast.success(res.data.message);
          setToastMessage(res.data.message);
          setShowToast(true);
          // AllPostList();
          setSelectedImage(imageName);
          setIsHovered(false);
          setIsLiking(false);
          setIsLiked(true);
          setLikedType(liketype);
          setChangeLikedType(liketype);
          if (typeof updateCommentLike === "function") {
            updateCommentLike(postId, currentCommentId, "like", liketype);
          }

        });
      } catch (e) {
        if (e.response && e.response.status === 404) {
          setWarningToastMessage(e.response.data.message);
          setShowWarningToast(true);
        } else {
          setErrorToastMessage(e.response.data.message);
          setShowErrorToast(true);
        }
      }
    }, 1000);
  };

  const unLikePost = async () => {
    if (isLiking) return;
    const responseData = {
      deviceType: "Web",
      sessionId: sessionId,
      id: currentCommentId,
      langKey: language === "en" ? "" : language,

    };
    setIsLiking(true);
    setTimeout(async () => {
      try {
        const res = await axios.post(`PostAction/UnlikeComment`, responseData);
        // .then((res) => {
        // console.log(res);
        // toast.success(res.data.message);
        setToastMessage(res.data.message);
        setShowToast(true);
        // AllPostList();
        setIsHovered(false);
        setIsHoveredRelike(false);
        setIsLiking(false);
        setIsLiked(false);
        setLikedType(null);
        if (typeof updateCommentLike === "function") {
          updateCommentLike(postId, currentCommentId, "unlike");
        }
        if (typeof setPostList === "function") {
          setPostList((prevList) =>
            prevList.map((post) => {
              if (post.postInfo.postId !== postId) return post;

              return {
                ...post,
                postInfo: {
                  ...post.postInfo,
                  comments: (post.postInfo.comments || []).map((c) => {
                    const commentKey = c?.pstCmntId ?? c?.commentId;
                    if (String(commentKey) !== String(currentCommentId)) return c;
                    return {
                      ...c,
                      isLiked: false,
                      likedType: null,
                      likeCount: c.isLiked
                        ? Math.max((c.likeCount || 0) - 1, 0)
                        : c.likeCount,
                    };
                  }),
                },
              };
            })
          );
        }
        // const postDetailsResponse = await axios.get(
        //   `/Posts/GetPostInfo?DeviceType=Web&PostId=${postId}&RestrictedViewerToken=${restrictedViewerToken}&langKey=${language}`
        // );
        // console.log("postDetailsResponse", postDetailsResponse);
        // const updatedPost = postDetailsResponse.data.responseData;
        // console.log("updatedPost", updatedPost);

        // setPostList((prev) =>
        //   prev.map((post) =>
        //     post.postId === updatedPost.postId ? updatedPost : post
        //   )
        // );

        // console.log('checking like conditions', isLiked, item?.isLiked);
      } catch (e) {
        if (e.response && e.response.status === 404) {
          setWarningToastMessage(e.response.data.message);
          setShowWarningToast(true);
        } else {
          setErrorToastMessage(e.response.data.message);
          setShowErrorToast(true);
          // Revert optimistic update
          setIsLiked(true);
          setLikedType(item?.likedType);
          if (typeof setPostList === "function") {
            setPostList((prevList) =>
              prevList.map((post) => {
                if (post.postInfo.postId !== postId) return post;

                return {
                  ...post,
                  postInfo: {
                    ...post.postInfo,
                    comments: (post.postInfo.comments || []).map((c) => {
                      const commentKey = c?.pstCmntId ?? c?.commentId;
                      if (String(commentKey) !== String(currentCommentId)) return c;
                      return {
                        ...c,
                        isLiked: true,
                        likedType: item?.likedType,
                        likeCount: c.likeCount + 1,
                      };
                    }),
                  },
                };
              })
            );
          }
        }
        // Ensure any reaction picker is hidden after an error as well
        setIsHovered(false);
        setIsHoveredRelike(false);
      }
    }, 1000);
  };

  //************************like Post End  ************************//

  const [showCommentsReply, setShowCommentsReply] = useState(false);
  const [replyFocusTrigger, setReplyFocusTrigger] = useState(0);

  const openReplyComment = () => {
    setShowCommentsReply(true);
    setReplyFocusTrigger((prev) => prev + 1);
  };

  const closeReplyComment = () => {
    setShowCommentsReply(false);
  };
  // console.log("item.likeCount", item.likeCount);
  const customCount = item.likeCount + 1;
  // console.log("customCount", customCount);

  const [showCommentLikeModal, setShowCommentLikeModal] = useState(false);
  const [postCommentId, setPostCommentsId] = useState(false);
  const [commentsLikedType, setCommentsLikedType] = useState(false);

  const handleShowCommentLike = (item) => {
    console.log("hghjsjhgsjhg", item.pstCmntId);

    setPostCommentsId(currentCommentId);
    setCommentsLikedType(item.likedType);
    // console.log("item comment id", item);
    setShowCommentLikeModal(true);
  };

  const handleCommentLikeCloseModal = () => {
    setShowCommentLikeModal(false);
  };
  const [changeLikedType, setChangeLikedType] = useState(null);

  const getLikeCount = () => {
    if (isLiked || item.isLiked) {
      // Agar pehle se like nahi tha aur ab like ho gaya
      if (!item.isLiked && isLiked) {
        return item.likeCount + 1;
      }
      // Agar pehle se like tha aur ab bas type change ho raha hai
      return item.likeCount;
    }
    return item.likeCount;
  };

  const ReLikePost = async (liketype, imageName) => {
    if (isLiking) return;
    const currentLikedType = changeLikedType ?? (isLiked ? likedType : null);

    if (Number(currentLikedType) === Number(liketype)) {
      setIsHoveredRelike(false);
      return;
    }

    // If it wasn't liked before, this is a new like (delegate to LikePost)
    const wasLiked = Boolean(isLiked);
    if (!wasLiked) {
      setIsHoveredRelike(false);
      return LikePost(liketype, imageName);
    }

    setChangeLikedType(liketype);
    try {
      const responseData = {
        deviceType: "Web",
        sessionId: sessionId,
        pstCmntId: currentCommentId,
        likeType: liketype,
        langKey: language === "en" ? "" : language,

      };
      setIsLiking(true);
      setLikedType(liketype);

      const res = await axios.post("/PostAction/ChangeCommentLikeType", responseData);

      setToastMessage(res.data.message);
      setShowToast(true);
      setSelectedImage(imageName);
      setIsHoveredRelike(false);
      setIsLiking(false);
      setIsLiked(true);
      setLikedType(liketype);
      setChangeLikedType(liketype);
      if (typeof updateCommentLike === "function") {
        updateCommentLike(postId, currentCommentId, "change", liketype);
      }
    } catch (e) {
      console.log(e);
      if (e.response) {
        if (e.response.status === 404) {
          setWarningToastMessage(e.response.data?.message || "Not found");
          setShowWarningToast(true);
        } else {
          setErrorToastMessage(e.response.data?.message || "Something went wrong");
          setShowErrorToast(true);
        }
      } else {
        setErrorToastMessage(e.message || "Unexpected error occurred");
        setShowErrorToast(true);
      }
      setChangeLikedType(item?.likedType);
    }
  };

  const currentLikedType = changeLikedType ?? (isLiked ? likedType : null);

  const [followModal, setFollowModal] = useState(false);
  const closeModalData = () => {
    setFollowModal(false);
  };

  return (
    <>

      {guestModeData === "true" ? (

        <div className="commentAction ms-3 d-flex align-items-center">
          <span
            className="CommentlikeActions d-flex align-items-center"
            onMouseEnter={isLiked ? openRelikeBar : openLikeBar}
            onMouseLeave={isLiked ? closeRelikeBar : closeLikeBar}
          >

            {isLiked === true ? (
              <div
                className="like-container pointer d-flex align-items-center me-2"
                whileHover={{ scale: 1.3 }}
                onClick={() => {
                  setFollowModal(true);
                }}
                onMouseEnter={openRelikeBar}
                onMouseLeave={closeRelikeBar}
              >
                {/* Use the new currentLikedType variable here */}
                {currentLikedType === 1 ? (
                  <>
                    <img src={post.LikeGif} width={15} className="likepadding" />
                    <p className="f-12 ms-1">{t("Newsfeed.Like")} </p>
                  </>
                ) : currentLikedType === 2 ? (
                  <>
                    <img src={post.LoveGif} width={15} className="likepadding" />
                    <p className="f-12 ms-1"> {t("Newsfeed.Love")} </p>
                  </>
                ) : currentLikedType === 3 ? (
                  <>
                    <img src={post.LaughingGif} width={15} className="likepadding" />
                    <p className="f-12 ms-1"> {t("Newsfeed.Laugh")}</p>
                  </>
                ) : currentLikedType === 4 ? (
                  <>
                    <img src={post.WowGif} width={15} className="likepadding" />
                    <p className="f-12 ms-1"> {t("Newsfeed.Wow")}</p>
                  </>
                ) : currentLikedType === 5 ? (
                  <>
                    <img src={post.AngryGif} width={15} className="likepadding" />
                    <p className="f-12 ms-1"> {t("Newsfeed.Angry")}</p>
                  </>
                ) : (
                  <>
                    <img src={post.LikeGif} width={15} className="likepadding" />
                    <p className="f-12 ms-1">{t("Newsfeed.Like")}</p>
                  </>
                )}
              </div>
            ) : (
              <motion.span
                className="f-12 me-2 pointer"
                onMouseEnter={openLikeBar}
                onMouseLeave={closeLikeBar}
                onClick={() => {
                  setFollowModal(true);
                }}
              >
                {t("Newsfeed.Like")}
              </motion.span>
            )}
            {isLiked === true ? (
              <span
                className="commentLike me-2"
                onClick={() => {
                  setFollowModal(true);
                }}  >
                {getLikeCount()}
              </span>
            ) : item.likeCount > 0 ? (
              <span
                className="commentLike me-2 like-details"
                onClick={() => {
                  setFollowModal(true);
                }}
              >
                {isLiked === true
                  ? `${item.likeCount} + ${customCount}`
                  : `${item.likeCount}`}
              </span>
            ) : (
              ""
            )}

            {isHovered && (
              <motion.div
                className="reactionsHolder"
                onMouseEnter={openLikeBar}
                onMouseLeave={closeLikeBar}
                variants={list}
                animate={isHovered ? "visible" : "hidden"}
              >
                {emojiList?.map((item) => {
                  return (
                    <div className="emoji-container" key={item.value}>
                      <motion.img
                        whileHover={{ scale: 1.5 }}
                        src={item.url}
                        alt=""
                        onClick={() => {
                          setFollowModal(true);
                        }}
                      />
                      <span className="emoji-name">{item.name}</span>
                    </div>
                  );
                })}
              </motion.div>
            )}
            {isHoveredRelike && (
              <motion.div
                className="reactionsHolder"
                onMouseEnter={openRelikeBar}
                onMouseLeave={closeRelikeBar}
                variants={list}
              >
                {emojiList?.map((item) => {
                  return (
                    <div className="emoji-container" key={item.value}>
                      <motion.img
                        whileHover={{ scale: 1.5 }}
                        src={item.url}
                        alt=""
                        onClick={() => {
                          setFollowModal(true);
                        }}
                      />
                      <span className="emoji-name">{item.name}</span>
                    </div>
                  );
                })}
              </motion.div>
            )}
          </span>
          ·
          <span className="f-12 pointer ms-1" onClick={() => {
            setFollowModal(true);
          }}>
            {t("Newsfeed.Reply")}
          </span>
        </div>
      ) : (
        <>
          <div className="commentAction ms-3 d-flex align-items-center">
            <span
              className="CommentlikeActions d-flex align-items-center"
              onMouseEnter={isLiked ? openRelikeBar : openLikeBar}
              onMouseLeave={isLiked ? closeRelikeBar : closeLikeBar}
            >
              {/* {isLiked === true || item.isLiked === true ? (
            <div
              className="like-container pointer d-flex align-items-center me-2"
              // onClick={() => unLikePost()}
              // whileHover={{ scale: 1.3 }}
              onMouseEnter={openRelikeBar}
              onMouseLeave={closeRelikeBar}
              onClick={() => {
                if (!isHoveredRelike) {
                  unLikePost();
                }
              }}
            >
              {currentLikedType === 1 ? (
                <>
                  <img src={post.LikeGif} width={15} className="likepadding" />
                  <p className="f-12 ms-1">Like</p>
                </>
              ) : currentLikedType === 2 ? (
                <>
                  <img src={post.LoveGif} width={15} className="likepadding" />
                  <p className="f-12 ms-1">Love</p>
                </>
              ) : currentLikedType === 3 ? (
                <>
                  <img
                    src={post.LaughingGif}
                    width={15}
                    className="likepadding"
                  />
                  <p className="f-12 ms-1">Laugh</p>
                </>
              ) : currentLikedType === 4 ? (
                <>
                  <img src={post.WowGif} width={15} className="likepadding" />
                  <p className="f-12 ms-1">Wow</p>
                </>
              ) : currentLikedType === 5 ? (
                <>
                  <img src={post.AngryGif} width={15} className="likepadding" />
                  <p className="f-12 ms-1">Angry</p>
                </>
              ) : (
                <>
                  <img src={post.LikeGif} width={15} className="likepadding" />
                  <p className="f-12 ms-1">Like</p>
                </>
              )}
            </div> */}
              {isLiked === true ? (
                <div
                  className="like-container pointer d-flex align-items-center me-2"
                  whileHover={{ scale: 1.3 }}
                  onClick={() => unLikePost()}
                  onMouseEnter={openRelikeBar}
                  onMouseLeave={closeRelikeBar}
                >
                  {/* Use the new currentLikedType variable here */}
                  {currentLikedType === 1 ? (
                    <>
                      <img src={post.LikeGif} width={15} className="likepadding" />
                      <p className="f-12 ms-1">{t("Newsfeed.Like")} </p>
                    </>
                  ) : currentLikedType === 2 ? (
                    <>
                      <img src={post.LoveGif} width={15} className="likepadding" />
                      <p className="f-12 ms-1"> {t("Newsfeed.Love")} </p>
                    </>
                  ) : currentLikedType === 3 ? (
                    <>
                      <img src={post.LaughingGif} width={15} className="likepadding" />
                      <p className="f-12 ms-1"> {t("Newsfeed.Laugh")}</p>
                    </>
                  ) : currentLikedType === 4 ? (
                    <>
                      <img src={post.WowGif} width={15} className="likepadding" />
                      <p className="f-12 ms-1"> {t("Newsfeed.Wow")}</p>
                    </>
                  ) : currentLikedType === 5 ? (
                    <>
                      <img src={post.AngryGif} width={15} className="likepadding" />
                      <p className="f-12 ms-1"> {t("Newsfeed.Angry")}</p>
                    </>
                  ) : (
                    <>
                      <img src={post.LikeGif} width={15} className="likepadding" />
                      <p className="f-12 ms-1">{t("Newsfeed.Like")}</p>
                    </>
                  )}
                </div>
              ) : (
                <motion.span
                  className="f-12 me-2 pointer"
                  onMouseEnter={openLikeBar}
                  onMouseLeave={closeLikeBar}
                  onClick={() => {
                    LikePost(1, like);
                  }}
                >
                  {t("Newsfeed.Like")}
                </motion.span>
              )}
              {isLiked === true ? (
                <span
                  className="commentLike me-2"
                  onClick={() => handleShowCommentLike(item)}  >
                  {getLikeCount()}
                </span>
              ) : item.likeCount > 0 ? (
                <span
                  className="commentLike me-2 like-details"
                  onClick={() => handleShowCommentLike(item)}
                >
                  {isLiked === true
                    ? `${item.likeCount} + ${customCount}`
                    : `${item.likeCount}`}
                </span>
              ) : (
                ""
              )}

              {isHovered && (
                <motion.div
                  className="reactionsHolder"
                  onMouseEnter={openLikeBar}
                  onMouseLeave={closeLikeBar}
                  variants={list}
                  animate={isHovered ? "visible" : "hidden"}
                >
                  {emojiList?.map((item) => {
                    return (
                      <div className="emoji-container" key={item.value}>
                        <motion.img
                          whileHover={{ scale: 1.5 }}
                          src={item.url}
                          alt=""
                          onClick={() => {
                            LikePost(item.value, item.name);
                          }}
                        />
                        <span className="emoji-name">{item.name}</span>
                      </div>
                    );
                  })}
                </motion.div>
              )}
              {isHoveredRelike && (
                <motion.div
                  className="reactionsHolder"
                  onMouseEnter={openRelikeBar}
                  onMouseLeave={closeRelikeBar}
                  variants={list}
                >
                  {emojiList?.map((item) => {
                    return (
                      <div className="emoji-container" key={item.value}>
                        <motion.img
                          whileHover={{ scale: 1.5 }}
                          src={item.url}
                          alt=""
                          onClick={() => {
                            ReLikePost(item.value, item.name);
                          }}
                        />
                        <span className="emoji-name">{item.name}</span>
                      </div>
                    );
                  })}
                </motion.div>
              )}
            </span>
            ·
            <span className="f-12 pointer ms-1" onClick={openReplyComment}>
              {t("Newsfeed.Reply")}
            </span>
          </div>
        </>
      )
      }

      {followModal && <ModalForGuest closeModalData={closeModalData} />}

      {showCommentsReply && (
        <CommentReply
          item={item}
          AllPostList={AllPostList}
          setPostList={setPostList}
          postId={postId}
          commentId={currentCommentId}
          focusTrigger={replyFocusTrigger}
          toggleReplyComment={closeReplyComment}
        />
      )}

      <LikesDetails
        showCommentLikeModal={showCommentLikeModal}
        handleCommentLikeCloseModal={handleCommentLikeCloseModal}
        postCommentId={postCommentId}
        commentsLikedType={commentsLikedType}
      />

      <SuccessToast
        show={showToast}
        message={toastMessage}
        onClose={() => setShowToast(false)}
      />

      <WarningToast
        show={showWarningToast}
        message={warningToastMessage}
        onClose={() => setShowWarningToast(false)}
      />

      <ErrorToast
        show={showErrorToast}
        message={ErrorToastMessage}
        onClose={() => setShowErrorToast(false)}
      />
    </>
  );
};

export default CommentAction;
